
    const wrappers = document.querySelectorAll('.video-wrapper-home');

   
    if (wrappers.length > 0) {
      wrappers.forEach(wrapper => {
        const video = wrapper.querySelector('video');

        if (video) {
          wrapper.addEventListener('mouseenter', () => {
            wrapper.classList.add('is-hovered');
            video.play();
          });

          wrapper.addEventListener('mouseleave', () => {
             wrapper.classList.remove('is-hovered');
            video.pause();
            video.currentTime = 0; 
          });
        }
      });
    }



const pageOverlay = document.querySelector(".pageOverlay");
const menuPageOverlay = document.querySelector(".menuPageOverlay");
const mobileMenuTrigger = document.querySelector(".toggleMenu");
const mobileMenuCloseTrigger = document.querySelector(
  ".mobilemenu__close-trigger"
);
const mobileSearchTrigger = document.querySelector(".mobile-search__trigger");
const advancedFilterAllCollectionButton = document.querySelector(
  ".directory_label_0 a[title=All]"
);
const popupAdvancedFilterAllCollectionButton = document.querySelector(
  ".advanced-filter__popup-section .directory_label_0 a[title=All]"
);
const selectVehiclePopupTriggers = document.querySelectorAll(
  ".select-vehicle__popup-trigger"
);
const advancedFilterPopupSection = document.querySelector(
  ".advanced-filter__popup-section"
);
const megamenuTriggerButtons = document.querySelectorAll(
  ".megamenu__trigger-button"
);
const collapsibleTabTitles = document.querySelectorAll(
  ".collapsible-tab__title-wrapper"
);
const collapsibleTabData = document.querySelectorAll(".collapsible-tab__data");
const cartDrawerShoppingButton = document.querySelector(
  ".continue-shopping__button-wrapper .continue-shopping__button"
);
const footerSocialMenuItemTrigger = document.querySelector(".social-menu__trigger");

const openMobileMenu = () => {
  menuPageOverlay.classList.add("pageOverlay__visible");
  document.body.classList.add("mobile-menu__open");
};

const closeMobileMenu = () => {
  menuPageOverlay.classList.remove("pageOverlay__visible");
  document.body.classList.remove(
    "mobile-menu__open",
    "modal-active",
    "no-scroll"
  );
};

mobileMenuTrigger &&
  mobileMenuTrigger.addEventListener("click", openMobileMenu);
menuPageOverlay && menuPageOverlay.addEventListener("click", closeMobileMenu);
mobileMenuCloseTrigger &&
  mobileMenuCloseTrigger.addEventListener("click", closeMobileMenu);

mobileSearchTrigger &&
  mobileSearchTrigger.addEventListener("click", () => {
    document.body.classList.toggle("mobile-search__open");
  });

// document.addEventListener("readystatechange", () => {
//   if (document.readyState == "complete") {
//     advancedFilterAllCollectionButton &&
//       advancedFilterAllCollectionButton.click();
//   }
// });

megamenuTriggerButtons &&
  megamenuTriggerButtons.forEach((megamenuTriggerButton) => {
    megamenuTriggerButton.addEventListener("click", (e) => {
      e.currentTarget.parentElement.parentElement.classList.toggle(
        "mega-dropdown__open"
      );
    });
  });

// collapsibleTabTitles &&
//   collapsibleTabTitles.forEach((collapsibleTabTitle) => {
//     let collapsibleTabHeight =
//       collapsibleTabTitle.nextElementSibling.offsetHeight;
//     collapsibleTabTitle.nextElementSibling.style.height = "0";

//     // normal tab click
//     collapsibleTabTitle.addEventListener("click", (e) => {
//       e.currentTarget.parentElement.classList.toggle("collapsible-tab__open");
//       e.currentTarget.nextElementSibling.style.height = `${collapsibleTabHeight}px`;
//       if (
//         !e.currentTarget.parentElement.classList.contains(
//           "collapsible-tab__open"
//         )
//       ) {
//         e.currentTarget.nextElementSibling.style.height = "0";
//       }
//     });

   
//  document.querySelectorAll(".fitment_btn").forEach((btn) => {
//     btn.addEventListener("click", () => {
//       const parent = collapsibleTabTitle.parentElement;
      
//       if (parent.id === "make_tab" || parent.id === "year_tab") {
//         parent.classList.add("collapsible-tab__open");
//         parent.classList.add("active");
//         collapsibleTabTitle.nextElementSibling.style.height = `${collapsibleTabHeight}px`;
        
//         if (window.innerWidth <= 768) {
//           const makeTab = document.getElementById("make_tab");
//           if (makeTab) {
//             const yOffset = -120;
//             const y = makeTab.getBoundingClientRect().top + window.pageYOffset + yOffset;
            
//             window.scrollTo({
//               top: y,
//               behavior: "smooth"
//             });
//           }
//         }
//       }
//     });
//   });
// });




selectVehiclePopupTriggers &&
  selectVehiclePopupTriggers.forEach((selectVehiclePopupTrigger) => {
    selectVehiclePopupTrigger.addEventListener("click", () => {
      popupAdvancedFilterAllCollectionButton &&
        popupAdvancedFilterAllCollectionButton.click();
      pageOverlay.classList.add("pageOverlay__visible");
      advancedFilterPopupSection.classList.add(
        "advanced-filter__popup-section-visible"
      );
      document.body.classList.add("no-scroll");
    });
  });

pageOverlay.addEventListener("click", () => {
  pageOverlay.classList.remove("pageOverlay__visible");
  if (
    advancedFilterPopupSection.classList.contains(
      "advanced-filter__popup-section-visible"
    )
  ) {
    advancedFilterPopupSection.classList.remove(
      "advanced-filter__popup-section-visible"
    );
  }

  if (document.body.classList.contains("no-scroll")) {
    document.body.classList.remove("no-scroll");
  }
});

cartDrawerShoppingButton &&
  cartDrawerShoppingButton.addEventListener("click", (e) => {
    e.preventDefault();
    document.getElementById("cart-count-desktop").classList.remove("hover");
    document.getElementById("cart-count-desktop").classList.add("avoid");
    setTimeout(() => {
      document.getElementById("cart-count-desktop").classList.remove("avoid");
    }, 100);
  });

  footerSocialMenuItemTrigger && footerSocialMenuItemTrigger.addEventListener("click", (e) => {
    e.preventDefault();
    footerSocialMenuItemTrigger.nextElementSibling.classList.toggle("footer-social__dropdown-visible");
  })

const element = document.getElementById('shopify-section-header');
function addClassOnScroll() {
    if (window.scrollY > 10) {
        element.classList.add('sticky_header');
    } else {
        element.classList.remove('sticky_header');
    }
}
window.addEventListener('scroll', addClassOnScroll);

  document.addEventListener("click", (e) => {
    if (window.innerWidth > 768) return;
    const target = e.target.closest(".advanced-filter");
    if (target) {
      const details = document.querySelector(".mobile_toggle");
      if (details && details.hasAttribute("open")) {
        details.removeAttribute("open");
      }
    }
  });

  // Handle changes on #sortBy select
  document.addEventListener("change", (e) => {
    if (window.innerWidth > 768) return;
    const target = e.target;
    if (target && target.id === "sortBy") {
      const details = document.querySelector(".mobile_toggle");
      if (details && details.hasAttribute("open")) {
        details.removeAttribute("open");
      }
    }
  });

  function setupMobileToggleLogic() {
    if (window.innerWidth > 768) return;

    let openItems = document.querySelectorAll('.default-open');
    let toggleBtn = document.querySelector('.mobile_toggle');
    let closeBtn = document.querySelector('.close_btn');

    if (!toggleBtn) return;

    if (toggleBtn.hasAttribute('open')) {
      toggleBtn.removeAttribute('open');
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (toggleBtn.hasAttribute('open')) {
          toggleBtn.removeAttribute('open');
        }
      });
    }

    toggleBtn.addEventListener('click', function () {
      openItems.forEach(item => {
        if (!item.hasAttribute('open')) {
          item.setAttribute('open', '');
        }
      });
    });
 
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupMobileToggleLogic();

    let observer = new MutationObserver((mutations, obs) => {
      for (let mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          setupMobileToggleLogic();
          let mobileToggle = document.querySelector('.mobile_toggle');
if (window.innerWidth > 769 && mobileToggle) {
  mobileToggle.setAttribute('open', '');
}
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });


document.addEventListener("DOMContentLoaded", function() {
  const hamburger = document.querySelector('.menu_hamburger');
  const filterDrawer = document.querySelector('.filter_menu_drawer');

  if (hamburger && filterDrawer) {
    hamburger.addEventListener('click', function() {
      filterDrawer.classList.add('active');
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const closeButton = document.querySelector('.filter_close');
  const filterDrawer = document.querySelector('.filter_menu_drawer');

  if (closeButton && filterDrawer) {
    closeButton.addEventListener('click', function() {
      filterDrawer.classList.remove('active'); // Replace 'active' with the class you added
    });
  }
});

document.querySelectorAll(".fitment_btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    const makeTab = document.getElementById("make_tab");
    const yearTab = document.getElementById("year_tab");

    if (makeTab) makeTab.classList.toggle("highlighted");
    if (yearTab) yearTab.classList.toggle("highlighted");

    if (window.innerWidth <= 768 && makeTab) {
      const yOffset = -120;
      const y = makeTab.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth"
      });
    }
  });
});
window.addEventListener('scroll', function () {
  const searchContentSection = document.querySelector('.search_content');
  const advancedFiltersSection = document.querySelector('.advanced-filters__section');

  if (!searchContentSection || !advancedFiltersSection) return;

  const searchContentTop = searchContentSection.getBoundingClientRect().top;

  if (searchContentTop <= 0) {
    advancedFiltersSection.classList.add('scroll-fixed');
  } else {
    advancedFiltersSection.classList.remove('scroll-fixed');
  }
});